import { GoogleAccountsService } from './../../providers/google-accounts.service';
import { AfterViewInit, Component, OnInit, ViewChild, ElementRef, Inject, NgZone, AfterContentInit } from '@angular/core';
import { FirebaseService } from "../../providers/firebase.service";
import { Client } from "../../models/client";
import { SoftwareIntegrations } from "../../models/softwareIntegrations";
import { FacilityUser } from "../../models/facilityUser";
import { AccountTypesArray } from "../../models/AccountTypes";
import { isNullOrUndefined } from "util";
import { ScrollService } from "../../providers/scroll.service";
import { ShortUrlService } from "../../providers/short-url.service";
import { Router } from "@angular/router";
import { LoadingServiceProvider } from "../../providers/loading-service";
import { AWSConnectorService } from '../../providers/aws-connector';
import { environment } from 'ng2/environments/environment';
import * as _ from 'lodash';
import { DataTable } from 'primeng/primeng';
import { TableService } from '../../providers/table-service.service';
import { DOCUMENT } from '@angular/common';

var AWS = require('aws-sdk');
var sqs = new AWS.SQS();

@Component({
  selector: 'app-portal-home',
  templateUrl: './portal-home.component.html',
  styleUrls: ['./portal-home.component.css'],
})
export class PortalHomeComponent implements OnInit, AfterViewInit, AfterContentInit {
  displayDialog: boolean;
  displayFacilityUserDialog: boolean;
  client: Client;
  selectedClient: Client;
  isNew: boolean;
  facilityUser: FacilityUser;
  test: any;
  facilityUserAccountTypes = new AccountTypesArray();

  totalClients: any;
  totalLocations: any;
  unitsRented: any;
  unitsReserved: any;
  payments: any;

  softwareIntegrations = new SoftwareIntegrations();
  facilities = [];
  tableFacilities = [];
  locations = [];
  isTableLoading: boolean;

  error: string;

  @ViewChild('dt') dt: DataTable;
  @ViewChild('gb') gb: ElementRef;

  get isProd() { return environment.env === 'prod' }

  constructor(
    public tableService: TableService,
    public afService: FirebaseService,
    private scroll: ScrollService,
    public shortUrl: ShortUrlService,
    private router: Router,
    private loading: LoadingServiceProvider,
    public goog: GoogleAccountsService,
    private awsConn: AWSConnectorService,
    private zone: NgZone,
    @Inject(DOCUMENT) private document: any,
  ) { }

  async ngOnInit() {
    this.isTableLoading = true;
    // no need to load these again when they are available already
    if (this.afService.facilitiesLoaded) {
      this.tableFacilities = this.afService.facilities;
      this.isTableLoading = false;
      this._setTableValues();
    }
    else {
      // load the clients in chunks
      var facilityChunkSub = this.afService.facilityChunkLoaded.subscribe((facilityChunk) => {
        this.tableFacilities = this.tableFacilities.concat(facilityChunk);
        // we can show the table after the first chunk comes in
        this.isTableLoading = false;
      });
    }
    this.afService.facilityKeysLoadedPromise().then(() => this.totalClients = _.keys(this.afService.facilityKeys).length);
    // this resolves once all of the facility chunks are loaded
    await this.afService.facilitiesLoadedPromise().then(() => {
      if (facilityChunkSub && !facilityChunkSub.closed) {
        facilityChunkSub.unsubscribe();
      }
    });
    if (this.isProd) {
      // get stats asynchronously
      this.afService.getTotalUnitsRented().then(val => this.unitsRented = val);
      this.afService.getTotalUnitsReserved().then(val => this.unitsReserved = val);
      this.afService.getTotalPayments().then(val => this.payments = val);
      this.afService.getTotalLocations().then(val => this.totalLocations = val);
    }
    this.facilities = [];
    _.each(this.afService.facilities, item => this.facilities.push({ label: item.name, value: item.$key }));
  }

  ngAfterViewInit() {
    this.scroll.scrollToTop();
  }

  ngAfterContentInit() {
    this.gb.nativeElement.focus();
  }

  getUrlStats() {
    this.shortUrl.getStatsByUrl(this.client.demoLinkShortUrl).toPromise().then((stats) => {
      this.shortUrl.shortLinkStats = stats;
    });
  }

  updateSettingsOnServer() {
    console.log(environment.env)
    var params = {
      MessageBody: environment.env,
      QueueUrl: 'https://sqs.us-east-1.amazonaws.com/729153069069/update-settings-to-client',
      DelaySeconds: 0,
      MessageAttributes: {
        clientCode: {
          DataType: 'String',
          StringValue: "update_all"
        },
      }
    };
    sqs.sendMessage(params, (err, data) => {
      if (err) {
        console.log(err, err.stack);
        this.afService.openSnackBar('ERROR');
      }
      else {
        console.log(data);
        this.afService.openSnackBar('Update settings added to SQS queue.');
      }
    });
  }

  goToLinkGraph(url) {
    this.loading.showLoading();
    this.displayDialog = false;
    this.shortUrl.getStatsByUrl(url).toPromise().then((stats) => {
      this.shortUrl.shortLinkStats = stats;
      this.shortUrl.shortLinkUrl = url;
      this.loading.hideLoading();
      this.router.navigate(['short-url-graph']);
    });
  }

  onRowSelect(event) {
    console.log(event);
    this.goog.setup();
    if (!event.originalEvent.toElement || event.originalEvent.toElement.className != 'mat-button-wrapper') {
      this.client = event.data;
      this.displayDialog = true;
      this.isNew = false;
    }
  }

  addDemoLinkUrl() {
    this.client.demoLinkUrl = 'https://';
  }

  async copyToProd() {
    if (confirm(`Are you sure you want to copy ${ this.client.name } to ${ environment.env === 'prod' ? 'staging' : 'prod' }?`)) {
      this.loading.showLoading();
      let clientData = {
        blogPosts: null,
        facilities: _.cloneDeep(this.client),
        locations: null,
        locationForms: null,
        locationsEsignInfo: null,
        emails: null
      };
      try {
        const data = await this.afService.getDataForCopyToProd(this.client);
        if (!isNullOrUndefined(data) && data.clientCode === this.client.code) {
          clientData.blogPosts = data.blogPosts;
          clientData.locations = data.locations;
          clientData.locationForms = data.locationForms;
          clientData.locationsEsignInfo = data.locationsEsignInfo;
          clientData.emails = data.emails;
          // if (clientData.facilities.reviewSettings) {
          //   delete clientData.facilities.reviewSettings;
          // }
          // if (clientData.facilities.reviews) {
          //   delete clientData.facilities.reviews;
          // }
          // for (let key in clientData.locations) {
          //   if (clientData.locations[key].reviewSettings) {
          //     delete clientData.locations[key].reviewSettings;
          //   }
          //   if (clientData.locations[key].reviews) {
          //     delete clientData.locations[key].reviews;
          //   }
          // }
          let copyToProdSub = this.awsConn.copyToProd(this.client.code, this.client.$key, clientData)
            .subscribe(rtn => {
              copyToProdSub.unsubscribe();
              console.log(rtn);
              this.loading.hideLoading();
              this.client = null;
              this.displayDialog = false;
            });
        }
      }
      catch (error) {
        console.log('copy to prod error:', error);
      }
    }
  }

  async deleteClient() {
    if (confirm(`Are you sure you want to delete ${ this.client.name }?`)) {
      this.loading.showLoading();
      try {
        let numLocations: number;
        if (this.isProd) {
          numLocations = await this.afService.softDeleteClient(this.client);
        }
        else {
          await this.afService.deleteClient(this.client);
        }
        this.displayDialog = false;
        if (numLocations > 0) {
          this.isTableLoading = true;
          this.afService.updateCounts(this.client, numLocations);
          this.totalLocations -= numLocations;
          this.totalClients--;
          this.facilities = _.filter(this.facilities, item => item.value !== this.client.$key);
          this.tableFacilities = _.filter(this.tableFacilities, item => item.value !== this.client.$key);
          this.tableService.filter = "";
          this._setTableValues();
          this.isTableLoading = false;
        }
        this.client = null;
        this.afService.openSnackBar('Success!');
      }
      catch (error) {
        console.log('delete client error:', error);
        this.afService.openSnackBar(error, 'ERROR!', 5000);
      }
      this.loading.hideLoading();
    }
  }

  // saveDemoLinkUrl() {
  //   this.afService.saveClientKey(this.client.$key, this.client.code);
  //   this.afService.updateClient(this.client).then(() => {
  //     this.afService.openSnackBar('Client successfully updated.');
  //   }).catch(e => {
  //     this.afService.openSnackBar(e.message);
  //   });
  // }

  generateShortUrl() {
    this.shortUrl.generateShortUrl(this.client.demoLinkUrl).toPromise().then((url) => {
      this.client.demoLinkShortUrl = url.shortUrl;
    });
  }

  onUserRowSelect(event) {
    this.facilityUser = event.data;
    this.displayFacilityUserDialog = true;
    this.isNew = false;
    this.getLocationKeys(this.facilityUser.facilityKeys);
  }

  sortTableByDate(event) {
    if (event.order === 1) {
      this.tableFacilities = _.sortBy(this.tableFacilities, f => new Date(f.dateLastDeployed));
    }
    else {
      this.tableFacilities = _.reverse(_.sortBy(this.tableFacilities, f => new Date(f.dateLastDeployed)));
    }
  }

  getLocationKeys(facilities, saveFacilityUser = false) {
    this.locations = [];
    if (!isNullOrUndefined(facilities)) {
      for (let item of facilities) {
        this.afService.getLocationsByKey(item).subscribe((locations) => {
          for (let location of locations) {
            this.locations.push({ label: location.name + ' | ' + location.address2, value: item + ',' + location.$key });
          }
        });
      }
    }
    if (saveFacilityUser) {
      this.saveFacilityUser();
    }
  }

  showDialogToAdd() {
    this.client = new Client();
    this.displayDialog = true;
    this.isNew = true;
  }

  showFacilityUserDialogToAdd() {
    this.facilityUser = new FacilityUser();
    this.displayFacilityUserDialog = true;
    this.isNew = true;
  }

  fillreCaptchaDemoDetails() {
    this.client.reCaptchaSiteKey = '6LfqDiIUAAAAAIojxIM6qd0_cSa2eUW4DGzRlfRd';
  }

  onFilterKeyUp(event) {
    if (event.keyCode === 13 && this.tableService.filteredValue.length > 0) {
      this.router.navigate(['/clients/', this.tableService.filteredValue[0].$key]);
    }
  }

  saveFacilityUser() {
    this.error = '';
    if (this.isNew) {
      this.afService.createAUser(this.facilityUser.email, this.facilityUser.initialPassword).then((userInfo) => {
        // console.log(userInfo);
        this.afService.createFacilityUser(this.facilityUser, userInfo.uid).then(() => {
          this.afService.openSnackBar('Client successfully updated.');
          this.displayFacilityUserDialog = false;
        }).catch(e => {
          this.afService.openSnackBar(e.message);
        });
      }).catch((err) => {
        this.error = err.message;
        // this.afService.openSnackBar(err.message);
      })
    }
    else {
      this.afService.updateFacilityUser(this.facilityUser).then(() => {
        this.displayFacilityUserDialog = false;
        this.afService.openSnackBar('Client successfully updated.');
      }).catch(e => {
        this.afService.openSnackBar(e.message);
      });
    }
  }

  setAnalytics() {
    this.client.analyticsId = this.goog.selectedAccountAnalyticsId;
    this.client.analyticsViewId = this.goog.selectedAccountViewId;
  }

  save() {
    if (this.client.siteUrl[this.client.siteUrl.length - 1] === '/') {
      this.client.siteUrl = this.client.siteUrl.slice(0, this.client.siteUrl.length - 1);
    }
    if (this.isNew) {
      var clientCode = this.client.code;
      this.afService.saveClient(this.client).then((client) => {
        // console.log(clientCode);
        // console.log(client.key);
        this.afService.saveClientKey(client.key, clientCode).then(async (data) => {
          // console.log(data);
          try {
            await this.afService.updateClientSoftware(this.client, true)
            this.afService.openSnackBar('Client successfully created.');
          } catch (e) {
            console.log(e)
            this.afService.openSnackBar(e.message);
          }
          this.client = null;
          this.displayDialog = false;
        }).catch(e => {
          console.log(e)
          this.afService.openSnackBar(e.message);
          this.client = null;
          this.displayDialog = false;
        });
      });
    }
    else {
      this.afService.saveClientKey(this.client.$key, this.client.code);
      // all of the client settings in the modal on this page
      //  || null is to prevent trying to save undefined which firebase doesn't like
      this.afService.updateClient(
        {
          name: this.client.name || null,
          tagLine: this.client.tagLine || null,
          code: this.client.code || null,
          siteUrl: this.client.siteUrl || null,
          hubspotCompanyId: this.client.hubspotCompanyId || null,
          logoUrl: this.client.logoUrl || null,
          pushRateThreshold: this.client.pushRateThreshold || null,
          numUnitsToShowUnitNumberLeft: this.client.numUnitsToShowUnitNumberLeft || null,
          suppressGetUnits: this.client.suppressGetUnits || null,
          propertySoftware: this.client.propertySoftware || null,
          storageCommanderLocId: this.client.storageCommanderLocId || null,
          reCaptchaSiteKey: this.client.reCaptchaSiteKey || null,
          primaryHex: this.client.primaryHex || null,
          accentHex: this.client.accentHex || null,
          analyticsId: this.client.analyticsId || null,
          analyticsViewId: this.client.analyticsViewId || null,
          rentReserveButtonClick: this.client.rentReserveButtonClick || null,
          rentReserveButtonClickTrackingCode: this.client.rentReserveButtonClickTrackingCode || null,
          rentReserveSuccessPageTrack: this.client.rentReserveSuccessPageTrack || null,
          rentReserveSuccessPageTrackingCode: this.client.rentReserveSuccessPageTrackingCode || null,
          contactFormSubmitTrack: this.client.contactFormSubmitTrack || null,
          contactFormSubmitTrackingCode: this.client.contactFormSubmitTrackingCode || null,
          instantQuoteSubmitTrack: this.client.instantQuoteSubmitTrack || null,
          instantQuoteSubmitTrackingCode: this.client.instantQuoteSubmitTrackingCode || null,
        }, this.client.$key).then(async () => {
          try {
            await this.afService.updateClientSoftware(this.client, false)
            this.afService.openSnackBar('Client successfully updated.');
          } catch (e) {
            console.log(e)
            this.afService.openSnackBar(e.message);
          }
          this.client = null;
          this.displayDialog = false;
        }).catch(e => {
          this.afService.openSnackBar(e.message);
          this.client = null;
          this.displayDialog = false;
        });
    }
  }

  private _setTableValues() {
    this.zone.runOutsideAngular(() => {
      setTimeout(() => {
        this.zone.run(() => {
          this.dt.onPageChange(this.tableService.page);
          if (this.tableService.filter) {
            // this is what primeng checks to update the global filter
            this.document.getElementById('global-filter').dispatchEvent(new KeyboardEvent('keyup'))
          }
        });
      });
    })
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/portal-home/portal-home.component.ts